import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePhonenumberDialogComponent } from './change-phonenumber-dialog.component';

import { DialogLayoutModule } from '@fleet/ui/dialog-layout/dialog-layout.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ProgressButtonModule } from '@fleet/ui/progress-button/progress-button.module';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { FuseAlertModule } from '@fleet/fuse';
import { AlertsFromIssuesModule } from '@fleet/issue';
import { MatInputModule } from '@angular/material/input';
@NgModule({
  declarations: [ChangePhonenumberDialogComponent],
  imports: [
    CommonModule,
    DialogLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    ProgressButtonModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatDialogModule,
    FuseAlertModule,
    AlertsFromIssuesModule,
  ],
  exports: [ChangePhonenumberDialogComponent],
})
export class ChangePhonenumberDialogModule {}
